module.exports = __webpack_public_path__ + "img/多肽订购.774e8508.png";